<template>
  <div id="map">
    <div class="search-username">
      <el-input placeholder="输入账号查询" v-model="username" @keydown.enter.native="search" class="input-with-select">
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <el-button type="primary" icon="el-icon-close" class="clear-button" @click="clearSearch" v-if="showInfo"></el-button>
    <el-button type="info" icon="el-icon-download" class="download-button" @click="downloadReport" round></el-button>
    <el-select v-model="value" placeholder="请选择" class="date-select" @change="selectDate">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-select v-model="group" placeholder="请选择" class="group-select" @change="selectGroup">
      <el-option
        v-for="item in options1"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <div class="info" v-if="showInfo">
      <p>累计时长：{{info.usetimeSum}} 分钟</p>
      <p>客户响应：{{info.locationCount}} 次</p>
      <p>平均响应：{{info.avaTime}} 分钟/次</p>
    </div>
  </div>
</template>

<script>
import {
  Scene,
  PointLayer,
  Popup
} from '@antv/l7';
import {
  GaodeMap
} from '@antv/l7-maps';
import Global from "./Global";

export default {
  name: "location",
  mounted() {
    this.initScene(this);
  },
  data() {
    return {
      // 显示需要坐标点的数据
      allData: null,
      // 地图
      map: null,
      // 地图场景
      scene: null,
      ssid: '',
      // 用户名字
      username: '',
      // 是否显示某个用户信息
      showInfo: false,
      // 用户信息
      info: {
        usetimeSum: 0,
        locationCount: 0,
        avaTime: 0
      },
      options: [{
        value: 1,
        label: '近一个月'
      }, {
        value: 3,
        label: '近三个月'
      }, {
        value: 6,
        label: '近半年'
      }, {
        value: 12,
        label: '近一年'
      }],
      value: 12,
      options1: [
        {
        value: 0,
        label: '思多科'
      },
      {
        value: 1,
        label: '复塑'
      }],
      group:''
    }
  },
  methods: {
    // 渲染地图数据
    initScene(that) {
      // 只有地图不存的时候才会重新生成
      if (that.map == null) {
        that.map = new GaodeMap(
          {
            style: "light", // 样式URL
            center: [120.19382669582967, 30.258134],
            pitch: 0,
            zoom: 3.7,
            token: "009cebdd6eed59aa0e6c64f21b6038ac"
          }
        )
      }
      // 只有场景不存在的时候，才会重新生成
      if (that.scene == null) {
        that.scene = new Scene({
          id: "map",
          map: that.map,
          logoVisible: false
        });
      }
      // 获取地图数据
      that.axios({
        method: 'GET',
        url: Global.accountUrl + "/storkCollectData/getAllLocation?months=" + that.value + "&group=" + that.group
      }).then(response => {
        that.allData = response.data.data
        let pointLayer = that.getPointLayer(false, response.data.data)
        that.scene.removeAllLayer()
        that.scene.addLayer(pointLayer)
      })
    },

    search() {
      this.info.usetimeSum = 0
      this.info.locationCount = 0

      this.showInfo = true

      this.scene.removeAllLayer()

      let that = this
      if(this.username == null || this.username == '')
      {
        that.$message.error('设备号不能为空');
      }else{
        this.axios({
        method: 'GET',
        url: Global.accountUrl + "/storkCollectData/getLocationByUsername?username=" + that.username + "&months="
          + that.value
      }).then( response => {
        let pointLayer = that.getPointLayer(true, response.data.data)
        that.scene.addLayer(pointLayer)

        that.getInfoByUsername(response.data.data, that)
      });
      }
    },

    clearSearch() {
      this.showInfo = false
      this.username = ''
      this.initScene(this)
    },

    getPointLayer(isByUsername, data) {
      let pointLayer = new PointLayer({})
        .source(data, {
          parser: {
            type: "json",
            x: "longitude",
            y: "latitude"
          }
        })
        .active(true)
        .shape('circle')
        .size('useTime', [40, 60])
        .color('red')
        .animate(true)
        .style({
          opacity: 0.3,
          strokeWidth: 1
        });

      pointLayer.on('mousemove', e => {
        let usetime = (e.feature.useTime / 1000 / 60).toFixed(2);
        let ssid = e.feature.ssid;
        let username = e.feature.username;
        const popup = new Popup({
          offsets: [0, 0],
          closeButton: false,
          maxWidth: 300
        })
          .setLnglat(e.lngLat)
          .setHTML(
            `<ul style = {
                        {
                          margin: 0,
                        }
                      }>
                        <li>用户名字：${username}</li>
                        <li>使用时长：${usetime} 分钟</li>
                        <li>探头编号：${ssid}</li>
                      </ul>`
          );
        this.scene.addPopup(popup);

        pointLayer.on("mouseout", e => {
          this.scene.removePopup(popup)
        })

      });

      pointLayer.on('click', e => {
        this.ssid = e.feature.ssid;
        this.setMsg();
      });
      return pointLayer;
    },

    getInfoByUsername(data, that) {
      that.info.locationCount = data.length
      for (let location of data) {
        let usetime = Math.floor(location.useTime/1000/60)
        that.info.usetimeSum += usetime
      }
      that.info.avaTime = Math.floor(that.info.usetimeSum / that.info.locationCount)
    },

    setMsg() {
      this.$emit('getSSID', this.ssid);
    },

    downloadReport() {
      this.$confirm('是否下载年终报告?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios({
          method: 'GET',
          url: Global.accountUrl + "/storkCollectData/getUserData",
          responseType: 'blob'
        }).then(response => {
          let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let url = URL.createObjectURL(blob)
          window.open(url)
          this.$message({
            type: 'success',
            message: '正在下载'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消下载'
        })
      })
    },

    selectDate(e) {
      if (this.showInfo) {
        this.search()
      } else {
        this.initScene(this)
      }
    },
    selectGroup(e) {
      if (this.showInfo) {
        this.search()
      } else {
        this.initScene(this)
      }
    }
  }
}
</script>

<style scoped>
#map {
  position: relative;
  height: 100%;
}
.search-username {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}
.clear-button {
  position: absolute;
  left: 268px;
  top: 11px;
  z-index: 1;
  height: 38px;
  background-color: #CCD1D1;
  border: #8c939d;
}
.info {
  position: absolute;
  right: 10px;
  top: 10px;
  height: 120px;
  width: 200px;
  background-color: #CCD1D1;
  border-radius: 10px;
  z-index: 1;
  align-content: center;
  padding: 10px;
}
.download-button {
  position: absolute;
  left: 10px;
  bottom: 10px;
  z-index: 1;
  height: 38px;
  background-color: #CCD1D1;
  border: #8c939d;
}
.date-select {
  position: absolute;
  width: 202px;
  left: 10px;
  top: 50px;
  z-index: 1;
  height: 38px;
  background-color: #CCD1D1;
  border: #8c939d;
}
.group-select {
  position: absolute;
  width: 202px;
  left: 10px;
  top: 90px;
  z-index: 1;
  height: 38px;
  background-color: #CCD1D1;
  border: #8c939d;
}
</style>



// WEBPACK FOOTER //
// src/components/Location.vue